import MicrositeRow from '~/components/MicrositeRow';
import MicrositePadding from '~/components/MicrositePadding';

export default function MicrositeSection({
	children,
	fill,
	id,
	padding,
}: {
	children: React.ReactNode;
	id?: string;
	fill?: boolean;
	padding?: boolean;
}) {
	return (
		<MicrositeRow fill={fill}>
			<MicrositePadding id={id} vertical={padding}>
				{children}
			</MicrositePadding>
		</MicrositeRow>
	);
}
